export default "__VITE_ASSET__ChaKLX5R__";